module.exports = __webpack_public_path__ + "static/media/LearnCreatorStepDefine.6a560431.jpg";